import { View } from "@/components/ui/view";
import { Camera } from 'expo-camera';
import React, { useEffect, useState } from 'react';
import { Alert, Platform } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import i18n from '../assets/i18n';
import Footer from '../components/basic/Footer';
import * as MediaSelector from '../components/media/MediaSelector';
import { switchScreen } from '../hooks/navigate';
import { wsSend } from "../stores/mainSlice";

const uuid = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i

export default function AuthenticateSession({ navigation }) {
    const [scanned, setScanned] = useState(null);
    const dispatch = useDispatch()
    const type = Camera.Constants.Type.back
    const server = useSelector((state) => state.server)

    useEffect(() => {
        MediaSelector.requestPermissions()
        MediaSelector.ensureDirExists()
    }, [])

    const handleBarCodeScanned = ({ type, data }) => {
        setScanned(true)
        console.log(type, data)
        if (data.match(uuid)) {
            switchScreen(navigation, 'BACK')
            const msg = { type: 'AUTH', receiver: [data], data: server.token.value };
            console.log('MSG', msg)
            dispatch(wsSend({msg: msg}))
            // dispatch(backendRequest('AUTHENTICATE_BROWSER_INLINE', '/qr/authenticate/' + data, { data: server.token.value }, 'POST', false))
        } else {
            Alert.alert(i18n.t('global.warning'), i18n.t('global.inValidQRCode'), [{ text: "OK", onPress: () => { }, }])
        }
    }

    const actionBack = () => {
        switchScreen(navigation, 'BACK')
    }

    return (
        <View className="flex-1">
            <Camera style={{ flex: 1, aspectRatio: 1, marginBottom: Platform.select({ android: 0, ios: 40 }) }} type={type}
                onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
            />
            <Footer navigation={navigation} button={{ action: actionBack, info: 'addContact.cancel' }} />
        </View>
    );
}
